// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSquare_container__I9rba","title":"ProductSquare_title__uXfvX","image":"ProductSquare_image__BB7iH"};